webpackJsonp([3,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var Shared = __webpack_require__(39);
	var Utils = __webpack_require__(25);
	var LanguageManager = __webpack_require__(38);
	var Carousel = __webpack_require__(670);
	
	var imgNL1 = __webpack_require__(931);
	var imgNL2 = __webpack_require__(932);
	var imgNL3 = __webpack_require__(933);
	var imgNL4 = __webpack_require__(934);
	
	var imgFR1 = __webpack_require__(927);
	var imgFR2 = __webpack_require__(928);
	var imgFR3 = __webpack_require__(929);
	var imgFR4 = __webpack_require__(930);
	
	var calendarNl = __webpack_require__(926);
	var calendarFr = __webpack_require__(925);
	
	var rulesNl = __webpack_require__(412);
	var rulesFr = __webpack_require__(411);
	
	__webpack_require__(910);
	
	$(function () {
	  Shared.init();
	  ActivitiesPage.init();
	});
	
	var ActivitiesPage = {};
	
	(function (ActivitiesPage) {
	  var carousel;
	
	  ActivitiesPage.init = function () {
	    $(".act-recipe-img").hide();
	
	    Utils.ImageSVGToSVG();
	
	    setupLinks();
	
	    setupCarousel();
	  };
	
	  function setupCarousel() {
	
	    var element = $(".carousel-wrapper");
	
	    carousel = new Carousel({
	      element: element,
	      centered: false,
	      clickCallBack: onCarouselClicked
	    });
	
	    element.on("afterChange", function (event, slick, currentSlide) {
	      var el = $(slick.$slides[currentSlide]).find(".recipe-slide");
	      var id = el.data("recipe-id");
	
	      window.location.hash = id;
	    });
	  }
	
	  function onCarouselClicked(e) {
	    var el = $(e.currentTarget).find(".recipe-slide");
	    var id = el.data("recipe-id");
	
	    $(".act-recipe-img").hide();
	    $(".act-recipe-img." + id).show();
	
	    $("#act-recipe-description-wide h2").html(LanguageManager.getValueForKey("recipes." + id + ".title"));
	    $("#act-recipe-description h2").html(LanguageManager.getValueForKey("recipes." + id + ".title"));
	    $("#act-recipe-description-wide div.recipe-description").html(LanguageManager.getValueForKey("recipes." + id + ".description"));
	    $("#act-recipe-description div.recipe-description").html(LanguageManager.getValueForKey("recipes." + id + ".description"));
	
	    $("#act-duration").html(LanguageManager.getValueForKey("recipes." + id + ".duration"));
	    $("#act-persons").html(LanguageManager.getValueForKey("recipes." + id + ".persons"));
	
	    $("#act-recipe-list-container").html(LanguageManager.getValueForKey("recipes." + id + ".ingredients"));
	
	    window.location.hash = id;
	  }
	
	  function setupLinks() {
	    $("a.img-nl-1").attr("href", imgNL1);
	    $("a.img-nl-2").attr("href", imgNL2);
	    $("a.img-nl-3").attr("href", imgNL3);
	    $("a.img-nl-4").attr("href", imgNL4);
	
	    $("a.img-fr-1").attr("href", imgFR1);
	    $("a.img-fr-2").attr("href", imgFR2);
	    $("a.img-fr-3").attr("href", imgFR3);
	    $("a.img-fr-4").attr("href", imgFR4);
	
	    var calendar;
	    var rules;
	    if (LanguageManager.getCurrentLocale() === "nl-BE") {
	      calendar = calendarNl;
	      rules = rulesNl;
	    } else {
	      calendar = calendarFr;
	      rules = rulesFr;
	    }
	
	    $("#act-sow-button").on("click", function (e) {
	      window.open(window.location.origin + calendar, "_blank");
	    });
	
	    $("#act-boardgame-button").on("click", function (e) {
	      window.open(window.location.origin + rules, "_blank");
	    });
	  }
	})(ActivitiesPage);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./fr-BE.json": 42,
		"./nl-BE.json": 43
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 37;


/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./recipe1.png": 1638,
		"./recipe10.png": 1639,
		"./recipe2.png": 1640,
		"./recipe3.png": 1641,
		"./recipe4.png": 1642,
		"./recipe5.png": 1643,
		"./recipe6.png": 1644,
		"./recipe7.png": 1645,
		"./recipe8.png": 1646,
		"./recipe9.png": 1647,
		"./thumb_recipe1.png": 1648,
		"./thumb_recipe10.png": 1649,
		"./thumb_recipe2.png": 1650,
		"./thumb_recipe3.png": 1651,
		"./thumb_recipe4.png": 1652,
		"./thumb_recipe5.png": 1653,
		"./thumb_recipe6.png": 1654,
		"./thumb_recipe7.png": 1655,
		"./thumb_recipe8.png": 1656,
		"./thumb_recipe9.png": 1657
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 669;


/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var utils = __webpack_require__(25);
	var LanguageManager = __webpack_require__(38);
	
	var recipesData = __webpack_require__(987);
	var recipesImages = __webpack_require__(669);
	
	module.exports = function () {
	  function RecipeCarousel(options) {
	    _classCallCheck(this, RecipeCarousel);
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.element = options.element;
	    this.startAt = utils.isNotNull(options.startAt) ? options.startAt.replace(/#/g, "") : "recept_id_1";
	    this.clickCallBack = options.clickCallBack;
	    this.centered = utils.isNotNull(options.centered) && options.centered !== undefined ? options.centered : false;
	    this.recipesData = recipesData.recipes;
	
	    this.create();
	  }
	
	  _createClass(RecipeCarousel, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderCarousel();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "getImageSource",
	    value: function getImageSource(id) {
	      var requireKey = "./thumb_recipe" + id + ".png";
	
	      if ($.inArray(requireKey, recipesImages.keys()) !== -1) {
	        return recipesImages(requireKey);
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderCarousel",
	    value: function renderCarousel() {
	      this.element.empty();
	
	      this.element.append("<button id='carousel-slider-prev' class='slider-btn slider-btn-prev'></button>");
	      this.element.append("<div id='recipes-carousel'></div>");
	      this.element.append("<button id='carousel-slider-next' class='slider-btn slider-btn-next'></button>");
	
	      var $carousel = $("#recipes-carousel");
	
	      for (var i = 0; i < this.recipesData.length; ++i) {
	        var f = this.recipesData[i];
	        var fIndex = f.replace("recept_id_", "");
	
	        var path = this.getImageSource(fIndex);
	
	        var slide = $("<div class='recipe-slide'></div>");
	        slide.append($("<img src='" + path + "' data-id='" + f + "' >"));
	        slide.attr("data-recipe-id", f);
	        slide.attr("data-recipe-index", fIndex);
	
	        $carousel.append(slide);
	      }
	
	      $carousel.slick({
	        centerMode: false,
	        focusOnSelect: false,
	        mobileFirst: true,
	        draggable: false,
	        swipe: true,
	        infinite: true,
	        prevArrow: $("#carousel-slider-prev"),
	        nextArrow: $("#carousel-slider-next"),
	        slidesToShow: 4,
	        slidesToScroll: 1,
	        responsive: [{
	          breakpoint: 950,
	          settings: {
	            slidesToShow: 4,
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 740,
	          settings: {
	            slidesToShow: 3,
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 520,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 0,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }]
	      });
	
	      var startSlideIndex = $(".slick-slider").find(".recipe-slide[data-recipe-id=" + this.startAt + "]").closest(".slick-slide").data("slick-index");
	
	      if (startSlideIndex === null) startSlideIndex = 1;
	      $carousel.slick("slickGoTo", startSlideIndex);
	
	      if (this.clickCallBack !== undefined && utils.isFunction(this.clickCallBack)) {
	        $(".slick-slider").on("click", ".slick-slide", this.clickCallBack);
	        //select the first (no 'afterChange')
	
	        $(".slick-slider").find(".recipe-slide[data-recipe-id=" + this.startAt + "]").closest(".slick-slide").click();
	      }
	
	      this.setUpEventListeners();
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {}
	  }]);
	
	  return RecipeCarousel;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 910:
907,

/***/ 925:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "70cf66683f38145c84d89664947ca065.pdf";

/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "06c70246b95c19c2e74c89818417859a.pdf";

/***/ }),

/***/ 927:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bac84938b6dbef1935bb577f1400aed7.pdf";

/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4598a9c863547dd9af90d559b02efdc8.pdf";

/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3981a7efffeb90981ba8147796b5b5ce.pdf";

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8b91766e88e8d13baba3728d768eb7fc.pdf";

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "da83b3ada69add3f2799e758e3bbdb5e.pdf";

/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e8f14a11ce4721cf1e776796e9b4aa41.pdf";

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "055a2f4e2d2427ae3ce84819a421ca10.pdf";

/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "871b1543139c74448af1354dfea0b72c.pdf";

/***/ }),

/***/ 987:
/***/ (function(module, exports) {

	module.exports = {"recipes":["recept_id_1","recept_id_2","recept_id_3","recept_id_4","recept_id_5","recept_id_6","recept_id_7","recept_id_8","recept_id_9","recept_id_10"]}

/***/ }),

/***/ 1638:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/recipe1.ab0d849.png";

/***/ }),

/***/ 1639:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/recipe10.195f3bd.png";

/***/ }),

/***/ 1640:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/recipe2.ca5720a.png";

/***/ }),

/***/ 1641:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/recipe3.d63ae4a.png";

/***/ }),

/***/ 1642:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/recipe4.b5cc210.png";

/***/ }),

/***/ 1643:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/recipe5.d71b3f5.png";

/***/ }),

/***/ 1644:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/recipe6.12d537e.png";

/***/ }),

/***/ 1645:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/recipe7.73f7b3d.png";

/***/ }),

/***/ 1646:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/recipe8.3caaaa9.png";

/***/ }),

/***/ 1647:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/recipe9.7eb0caf.png";

/***/ }),

/***/ 1648:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/thumb_recipe1.e9d7d0a.png";

/***/ }),

/***/ 1649:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/thumb_recipe10.de271d9.png";

/***/ }),

/***/ 1650:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/thumb_recipe2.b44da80.png";

/***/ }),

/***/ 1651:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/thumb_recipe3.961457f.png";

/***/ }),

/***/ 1652:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/thumb_recipe4.fc8d969.png";

/***/ }),

/***/ 1653:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/thumb_recipe5.056b8b0.png";

/***/ }),

/***/ 1654:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/thumb_recipe6.51b0497.png";

/***/ }),

/***/ 1655:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/thumb_recipe7.4183992.png";

/***/ }),

/***/ 1656:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/thumb_recipe8.5379ce8.png";

/***/ }),

/***/ 1657:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/thumb_recipe9.c90f720.png";

/***/ })

});


// WEBPACK FOOTER //
// js/activities.fe565ac3a3baf6501cf5.js